import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { countUsers, createSegment, getSegment, filterDropdownData } from '../../../../redux/actions/journeyAction';
import { COUNT_USERS_SUCCESS, RESET_USER_COUNT } from '../../../../constants/ActionTypes';

import AllPartnersFilters, { RenderAllPartnersFilter, buildAllPartnersDynamicFilters, processUserBehaviorFilters, processGeographyFilters, processDemographicsFilters, processPartnerCategoryFilters } from './AllPartnersFilters';
import PartnerLeadFilters, { buildPartnerLeadsDynamicFilters, buildPartnerLeadsDefaultFilters, PartnerLeadsSection, processPartnersLeadFilters } from './PartnersLead';
import ContactFilters, { ContactsSection, buildContactsDynamicFilters, processContactFilters } from './ContactFilters';

import { toast } from 'react-toastify';
import { useParams, Link, useNavigate } from "react-router-dom";
import { BsXCircle } from 'react-icons/bs';

const InlineFilters = (props) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user_count, count_loading, segment, filter_dropdowns } = useSelector(state => state.journey);
  const region = filter_dropdowns?.geographic?.region || [];
  const state = filter_dropdowns?.geographic?.state || [];
  const city = filter_dropdowns?.geographic?.city || [];

  const campaigns = filter_dropdowns?.campaigns || [];
  const journeys = filter_dropdowns?.journey_list || [];
  const lists = filter_dropdowns?.autoemail_list || [];
  const campaign = filter_dropdowns?.campaign || [];
  const landingpage = filter_dropdowns?.landingpage || [];
  const features = filter_dropdowns?.features || [];
  const leadstage = filter_dropdowns?.leadstage || [];

  const authToken = props.authToken || localStorage.getItem("authToken");
  useEffect(() => {
    dispatch(filterDropdownData(authToken));
    // Reset user count to 0 when component loads
    dispatch({ type: RESET_USER_COUNT }); 
    }, [dispatch, authToken]);
  
  // Get id from props or fallback to useParams
  const { id } = useParams();
  const segmentId = props.id || id;

  const [selectedPartner, setSelectedPartner] = useState("AllPartners");
  const [selectedUser, setSelectedUser] = useState("AllUsers");
  const [activeTab, setActiveTab] = useState("UserBehavior");
  const [filterValues, setFilterValues] = useState({
    Geography: {},
    Demography: {},
    UserBehavior: {},
    PartnerCategory: {},
    PartnerLeadDefault: {},
    Management: {},
    Contacts: {}
  });

  // State for managing dynamic filter list
  const [dynamicFilters, setDynamicFilters] = useState([]);
  const [showDefaultFilters, setShowDefaultFilters] = useState(false);
  // Separate visibility flag for Contacts default block
  const [showContactsDefault, setShowContactsDefault] = useState(true);
  const [isAutoemail, setIsAutoemail] = useState(false);
  const [saving, setSaving] = useState(false);
  const [counting, setCounting] = useState(false);
  const [downloadingExcel, setDownloadingExcel] = useState(false);
  const [showTotalUsers, setShowTotalUsers] = useState(false);
  // No auto-append of default rows on load for any partner type

  const handleIsAutoemailChange = (e) => {
    setIsAutoemail(e.target.checked);
  };

  // Load segment data when component mounts or segmentId changes
  useEffect(() => {
    if (segmentId && authToken) {
      dispatch(getSegment(authToken, segmentId));
    }
  }, [segmentId, authToken, dispatch]);


  // Sync isAutoemail checkbox with segment value when segment loads/changes
  useEffect(() => {
    if (segment && segment.is_autoemail !== undefined) {
      const checked = segment.is_autoemail === 1 || segment.is_autoemail === '1' || segment.is_autoemail === true;
      setIsAutoemail(checked);
    }
  }, [segment]);

  // When segment loads, set selectedPartner from its channel
  useEffect(() => {
    if (!segment) return;
    const ch = segment.channel;
    if (!ch) return;
    const v = String(ch).toLowerCase();
    if (v === 'allpartners' || v === 'all_partners') setSelectedPartner('AllPartners');
    else if (v === 'partnerleads' || v === 'partnersleads' || v === 'partner_leads') {
      setSelectedPartner('PartnerLeads');
      setShowDefaultFilters(true); // Show default filters directly
    }
    else if (v === 'contacts' || v === 'contact') setSelectedPartner('Contacts');
  }, [segment]);

  // Reset UI state on segment id change to avoid stale data between routes
  useEffect(() => {
    // Clear state immediately when switching ids
    setDynamicFilters([]);
    setFilterValues({ Geography: {}, Demography: {}, UserBehavior: {}, PartnerLeadDefault: {}, Management: {}, Contacts: {} });
    setSelectedUser("AllUsers");
    setShowDefaultFilters(false);
    setShowContactsDefault(true);
    setActiveTab("UserBehavior");
  }, [segmentId]);

  useEffect(() => {
    if (!segment) {
      // Ensure UI is cleared when no segment is present
      setDynamicFilters([]);
      setFilterValues({ Geography: {}, Demography: {}, UserBehavior: {}, PartnerLeadDefault: {}, Management: {}, Contacts: {} });
      setSelectedUser("AllUsers");
      setShowDefaultFilters(false);
      setActiveTab("UserBehavior");
      return;
    }
    const filtersFromApi = segment.filter || segment.filters || segment.selectedfilters; // support multiple keys from API

    // Always clear previous state first to prevent stale filters persisting across segments
    setDynamicFilters([]);
    setFilterValues({ Geography: {}, Demography: {}, UserBehavior: {}, PartnerCategory: {}, PartnerLeadDefault: {}, Management: {}, Contacts: {} });
    setSelectedUser("AllUsers");
    setShowDefaultFilters(false);
    setShowContactsDefault(true);
    setActiveTab("UserBehavior");
    
    if (!filtersFromApi) return;

    const hasAny = (filtersFromApi.partnersLeadFilters && filtersFromApi.partnersLeadFilters.length > 0)
      || (filtersFromApi.geographics && filtersFromApi.geographics.length > 0)
      || (filtersFromApi.demographics && filtersFromApi.demographics.length > 0)
      || (filtersFromApi.user_behaviour && filtersFromApi.user_behaviour.length > 0)
      || (filtersFromApi.partner_category && filtersFromApi.partner_category.length > 0)
      || (filtersFromApi.PartnerLeadDefault && filtersFromApi.PartnerLeadDefault.length > 0)
      || (filtersFromApi.leads && filtersFromApi.leads.length > 0)
      || (filtersFromApi.contactFilters && filtersFromApi.contactFilters.length > 0)
      || (Array.isArray(filtersFromApi.contacts) && filtersFromApi.contacts.length > 0);

    if (!hasAny) return;

    // Ensure UI shows applied filters section
    setSelectedUser("FilteredUsers");
      setShowDefaultFilters(false);
      setShowContactsDefault(false);

    const nextDynamic = [];

    // Use centralized builder for AllPartners dynamic filters
    const fromAllPartners = buildAllPartnersDynamicFilters(filtersFromApi);
    nextDynamic.push(...fromAllPartners);

    const PartnerLeadDefaultData = filtersFromApi.partnersLeadFilters || filtersFromApi.PartnerLeadDefault;
    const fromPartnerLeadDefaults = buildPartnerLeadsDefaultFilters(PartnerLeadDefaultData);
    nextDynamic.push(...fromPartnerLeadDefaults);

    // PartnerLeads dynamic filters
    const fromPartnerLeads = buildPartnerLeadsDynamicFilters(filtersFromApi);
    nextDynamic.push(...fromPartnerLeads);

    // Contacts dynamic filters via builder
    const fromContacts = buildContactsDynamicFilters(
      filtersFromApi.contacts || filtersFromApi.contactFilters || []
    );
    nextDynamic.push(...fromContacts);

    if (nextDynamic.length > 0) {
      setDynamicFilters(nextDynamic);
      // Set active tab to first restored filter type for better UX
      const firstType = nextDynamic[0].type;
      if (firstType === 'Demography') setActiveTab('Demography');
      else if (firstType === 'UserBehavior') setActiveTab('UserBehavior');
      else if (firstType === 'PartnerCategory') setActiveTab('PartnerCategory');
      else if (firstType === 'Management') setActiveTab('Management');
      else setActiveTab('UserBehavior');
    }
  }, [segment]);

  const handleUserChange = (user) => {
    setSelectedUser(user);
    setFilterValues({ Geography: {}, Demography: {}, UserBehavior: {}, Management: {}, Contacts: {} });
    setActiveTab("UserBehavior");
    setShowDefaultFilters(false);
    if (user === "FilteredUsers" && dynamicFilters.length === 0) {
      const userBehaviorFilter = { id: Date.now(), type: "UserBehavior", name: "User Behavior", filters: {} };
        setDynamicFilters([userBehaviorFilter]);
    }
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const handleAddAttributes = () => {
    let type, name, filters;
    if (selectedPartner === "PartnerLeads") {
      type = "Management";
      name = "PartnerLeadDefault";
      filters = filterValues.Management || {};
    } 
    else if (selectedPartner === "Contacts") {
      type = "Contacts";
      name = "Contacts";
      filters = filterValues.Contacts || {};
    } 
    else {
      // For AllPartners
      if (dynamicFilters.length === 0 && !showDefaultFilters) {
        // Ensure default filters remain visible AND also append the new filter
        setShowDefaultFilters(true);
      }
      type = activeTab;
      name = activeTab;
      filters = filterValues[activeTab] || {};
    }
  
    const newFilter = {
      id: Date.now(),
      type,
      name,
      filters,
    };
  
    setDynamicFilters((prev) => [...prev, newFilter]);

    // Do not auto-hide default filters; keep them until the user explicitly hides
  };

  // Function to remove a dynamic filter
  const handleRemoveFilter = (filterId) => {
    setDynamicFilters(prev => prev.filter(filter => filter.id !== filterId));
  };

  const renderFilterContent = (filterType, filterId) => {
    const filterContent = (() => {
      switch (filterType) {
        case "Geography":
        case "Demography":
        case "UserBehavior":
        case "PartnerCategory": {
          const currentValues = filterId 
            ? dynamicFilters.find(f => f.id === filterId)?.filters || {}
            : filterValues[filterType] || {};
          return (
            <RenderAllPartnersFilter
              type={filterType}
              currentValues={currentValues}
              onFilterChange={(field, value) => handleFilterChange(filterType, field, value, filterId)}
              region={region}
              state={state}
              city={city}
              campaigns={campaigns}
              journeys={journeys}
              lists={lists}
              features={features}
              campaign={campaign}
              landingpage={landingpage}
              partnerCategories={filter_dropdowns?.partner_category || []}
            />
          );
        }
        case "Management":
          return renderManagementFilters(filterId);
        case "Contacts":
          return renderContactFilters(filterId);
        default:
          return <div>Unknown filter type</div>;
      }
    })();

    // If it's a dynamic filter (has filterId), add the X button
    if (filterId) {
      return (
        <div className="row-cols-auto text-center row ms-2">
            {filterContent}
            <Col className="custom_col">
              <Button 
                variant="outline-danger" 
                size="sm"
                onClick={() => handleRemoveFilter(filterId)}
                className="ms-1 py-0 px-1"
              >
                ×
              </Button>
            </Col>
          </div>
      );
    }

    return filterContent;
  };

  const handleFilterChange = (category, field, value, filterId = null) => {
    if (filterId) {
      // Update dynamic filter
      setDynamicFilters(prev => prev.map(filter => 
        filter.id === filterId 
          ? { ...filter, filters: { ...filter.filters, [field]: value } }
          : filter
      ));
      return;
    }
    
    setFilterValues(prev => {
      const newValues = {
        ...prev,
        [category]: {
          ...prev[category],
          [field]: value
        }
      };

      // Clear dependent fields when parent selection changes
      if (category === "UserBehavior") {
        if (field === "specificBehavior") {
          // Clear all dependent fields when specificBehavior changes
          newValues[category].behaviorAttribute = "";
          newValues[category].startDate = "";
          newValues[category].endDate = "";
          newValues[category].numberOfTimesLoggedIn = "";
          newValues[category].contentType = "";
          newValues[category].numberOfShares = "";
          newValues[category].shareStartDate = "";
          newValues[category].shareEndDate = "";
          newValues[category].numberOfLeads = "";
          newValues[category].leadsStartDate = "";
          newValues[category].leadsEndDate = "";
          newValues[category].numberOfContacts = "";
          newValues[category].contactsStartDate = "";
          newValues[category].contactsEndDate = "";
          newValues[category].profileUpdatedStartDate = "";
          newValues[category].profileUpdatedEndDate = "";
          newValues[category].numberOfTasks = "";
          newValues[category].tasksStartDate = "";
          newValues[category].tasksEndDate = "";
          newValues[category].numberOfOpens = "";
          newValues[category].notificationsStartDate = "";
          newValues[category].notificationsEndDate = "";
          newValues[category].numberOfClicks = "";
          newValues[category].specificCampaign = "";
          newValues[category].clicksStartDate = "";
          newValues[category].clicksEndDate = "";
          newValues[category].whichJourney = "";
          newValues[category].completionStartDate = "";
          newValues[category].completionEndDate = "";
          newValues[category].syncedGmailContacts = "";
          newValues[category].syncedPhonebook = "";
          newValues[category].emailList = "";
          newValues[category].mostUsedFeature = "";
          newValues[category].featuresStartDate = "";
          newValues[category].featuresEndDate = "";
          newValues[category].inactiveDays = "";
        } else if (field === "behaviorAttribute") {
          // Clear Login dependent fields when behaviorAttribute changes
          newValues[category].startDate = "";
          newValues[category].endDate = "";
          newValues[category].numberOfTimesLoggedIn = "";
        }
      }

      return newValues;
    });
  };

const hasAnyValue = (obj = {}) => {
  return Object.values(obj || {}).some((v) => {
    if (v === null || v === undefined) return false;
    if (Array.isArray(v)) return v.length > 0;
    if (typeof v === 'object') return Object.keys(v).length > 0;
    return String(v).trim() !== '';
  });
};

const buildPayload = (action = "update") => {
  const payload = {
    segment_name: segment.segment_name || "",
    type: "dynamic",
    source: segment.source || "",
    channel: selectedPartner === "PartnerLeads" ? "PartnerLeads" : (selectedPartner === "Contacts" ? "Contacts" : (segment.channel || "")),
    action: action,
    id: typeof segmentId === 'string' ? Number(segmentId) : segmentId,
    is_autoemail: isAutoemail ? 1 : 0,
  };

  // Initialize container structures depending on partner selection
  if (selectedPartner === "PartnerLeads") {
    payload.filter = { leads: [] };
  } else if (selectedPartner === "Contacts") {
    payload.filter = { contacts: [] };
  } else if (selectedUser === "FilteredUsers") {
    payload.selectedfilters = { geographics: [], demographics: [], user_behaviour: [], partner_category: [] };
  } else {
    payload.selectedfilters = { AllUsers: "AllUsers" };
  }

  // ---------------- Helper Functions ----------------




  // ---------------- Apply Filters ----------------
  if (selectedPartner === "PartnerLeads") {
      if (hasAnyValue(filterValues.Management)) {
        processPartnersLeadFilters(filterValues.Management, payload);
      }
  } else if (selectedPartner === "Contacts") {
      if (hasAnyValue(filterValues.Contacts)) {
        processContactFilters(filterValues.Contacts, payload);
      }
  } else {
      if (hasAnyValue(filterValues.Geography)) processGeographyFilters(filterValues.Geography, payload);
      if (hasAnyValue(filterValues.Demography)) processDemographicsFilters(filterValues.Demography, payload);
      if (hasAnyValue(filterValues.UserBehavior)) processUserBehaviorFilters(filterValues.UserBehavior, payload);
      if (hasAnyValue(filterValues.PartnerCategory)) processPartnerCategoryFilters(filterValues.PartnerCategory, payload);
  }

  // Include only dynamic filters that actually have values
  const nonEmptyDynamics = (dynamicFilters || []).filter(df => hasAnyValue(df.filters));
  nonEmptyDynamics.forEach((dynamicFilter) => {
    if (selectedPartner === "PartnerLeads" && dynamicFilter.type === "Management") {
        processPartnersLeadFilters(dynamicFilter.filters, payload);
    } else if (selectedPartner === "Contacts" && dynamicFilter.type === "Contacts") {
        processContactFilters(dynamicFilter.filters, payload);
    } else {
        if (dynamicFilter.type === "Geography") processGeographyFilters(dynamicFilter.filters, payload);
        if (dynamicFilter.type === "Demography") processDemographicsFilters(dynamicFilter.filters, payload);
        if (dynamicFilter.type === "UserBehavior") processUserBehaviorFilters(dynamicFilter.filters, payload);
        if (dynamicFilter.type === "PartnerCategory") processPartnerCategoryFilters(dynamicFilter.filters, payload);
    }
  });

  return payload;
};

const handleSave = async () => {
  try {
    if (saving) return;
    setSaving(true);
    const payload = buildPayload();
    const response = await dispatch(createSegment(authToken, payload));
    if (response?.success) {
      // success handled by caller if needed
      setSaving(false);
    } else {
      setSaving(false);
    }
  } catch (error) {
    toast.error("Failed to save segment");
    setSaving(false);
  }
};

const handleShowCount = async () => {
  try {
    if (counting) return;
    setCounting(true);
    const payload = buildPayload("update");
    const result = await dispatch(countUsers(authToken, payload));
    if (result.success) {
      // The countUsers action already updates the Redux state
      // But if you want to manually dispatch an action to update user_count:
      dispatch({ 
        type: COUNT_USERS_SUCCESS, 
        payload: result.count 
      });
      // Show Total Users card after successful count
      setShowTotalUsers(true);
    }
  } catch (error) {
    // noop, toast can be added if needed
  } finally {
    setCounting(false);
  }
};

const handleDownloadExcel = async () => {
  try {
    if (downloadingExcel) return;
    setDownloadingExcel(true);
    const payload = buildPayload("download");
    const result = await dispatch(countUsers(authToken, payload));
    if (result.success) {
      // Handle download response if needed
      // The API might return a file URL or blob that needs to be handled
    }
  } catch (error) {
    // noop, toast can be added if needed
  } finally {
    setDownloadingExcel(false);
  }
};

  const renderManagementFilters = (filterId = null) => {
    const currentValues = filterId 
      ? dynamicFilters.find(f => f.id === filterId)?.filters || {}
      : filterValues.Management || {};
    return (
          <PartnerLeadFilters 
            filterValues={currentValues}
            campaigns={campaigns}
            journeys={journeys}
            lists={lists}
            features={features}
            campaign={campaign}
            landingpage={landingpage}
            leadstage={leadstage}
            region={region}
            state={state}
            city={city}  
            onFilterChange={(field, value) => handleFilterChange("Management", field, value, filterId)}
          />
        
    );
  };

  const renderContactFilters = (filterId = null) => {
    const currentValues = filterId 
      ? dynamicFilters.find(f => f.id === filterId)?.filters || {}
      : filterValues.Contacts || {};
      
    return (
          <ContactFilters 
            filterValues={currentValues}
            campaigns={campaigns}
            journeys={journeys}
            lists={lists}
            features={features}
            campaign={campaign}
            landingpage={landingpage}
            region={region}
            state={state}
            city={city}
            onFilterChange={(field, value) => handleFilterChange("Contacts", field, value, filterId)}
          />
    );
  };

  const renderAllPartnersFilters = () => (
      <AllPartnersFilters
        ctx={{
          selectedUser,
          showDefaultFilters,
          filterValues,
          onFilterChange: (category, field, value) => handleFilterChange(category, field, value),
          dynamicFilters,
          renderFilterContent,
          activeTab,
          handleTabClick,
          onUserChange: handleUserChange,
          onSetSelectedUser: setSelectedUser,
          onResetAllFilters: () => setFilterValues({ Geography: {}, Demography: {}, UserBehavior: {}, Management: {}, Contacts: {} }),
          onSetActiveTab: setActiveTab,
          onSetShowDefaultFilters: setShowDefaultFilters,
          onSetDynamicFilters: setDynamicFilters,
          onAddAllPartnersFilter: (tabName) => {
            const newFilter = { id: Date.now(), type: tabName, name: tabName, filters: {} };
            setDynamicFilters(prev => [...prev, newFilter]);
          },
          onHideDefaultFilters: () => setShowDefaultFilters(false)
        }}
      />
  );
  
  return (
    <>
    



      <Row className="mb-3 ps-3 mt-3">
        <Col className="col-10"> {selectedPartner} </Col>
        <Col className="col-2 d-flex justify-content-end">
          <button
          onClick={() => {
          setTimeout(() => {
          navigate("/segment");
          }, 100);
          }}
          className="btn btn-save d-flex align-items-center justify-content-center"
          >
           <BsXCircle className="me-2" /> Close
          </button>
        </Col>
      </Row>

  



    {selectedPartner === "AllPartners" && null}
    <div className="bg-white p-4 rounded shadow-sm filteres_div">
      {/* AllPartners Section */}
        {selectedPartner === "AllPartners" && renderAllPartnersFilters()}

      {/* PartnerLeads Section */}
      {selectedPartner === "PartnerLeads" && (
          <PartnerLeadsSection
            dynamicFilters={dynamicFilters}
            renderFilterContent={renderFilterContent}
            renderManagementFilters={renderManagementFilters}
            onResetDefault={() => setFilterValues(prev => ({ ...prev, Management: {} }))}
            onAddFilter={handleAddAttributes}
            showDefault={dynamicFilters.length === 0}
          />
      )}

      {/* Contacts Section */}
      {selectedPartner === "Contacts" && (
          <ContactsSection
            dynamicFilters={dynamicFilters}
            renderFilterContent={renderFilterContent}
            renderContactFilters={renderContactFilters}
            showDefault={showContactsDefault}
            onResetDefault={() => {
              setFilterValues(prev => ({ ...prev, Contacts: {} }));
              setShowContactsDefault(false);
            }}
            onAddFilter={handleAddAttributes}
          />
      )}
      {/* {(selectedUser !== "AllUsers" || selectedPartner === "PartnerLeads" || selectedPartner === "Contacts") && (
          <div className="mt-3">
            <Button 
              variant="link" 
              className="p-0 text-primary"
              onClick={handleAddAttributes}
            >
              + Attributes
            </Button>
          </div>
      )} */}
      
      <div className="segment-actions-container">
        <div className="segment-actions-left">
          <button
            className="segment-action-btn segment-action-btn-primary"
            onClick={handleShowCount}
            disabled={counting}
            type="button"
          >
            {counting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Counting...
              </>
            ) : (
              "Show Count"
            )}
          </button>
          {showTotalUsers && (
            <div className="total-users-card">
              <div className="total-users-label">Total Users</div>
              <div className="total-users-value">
                {count_loading ? (
                  <span className="loading-spinner-small"></span>
                ) : (
                  <span className="user-count-number">{user_count || 0}</span>
                )}
              </div>
              {user_count > 0 && (
                <button
                  className="download-excel-icon-btn"
                  onClick={handleDownloadExcel}
                  disabled={downloadingExcel}
                  type="button"
                  title="Download Excel"
                >
                  {downloadingExcel ? (
                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  ) : (
                    <img src={`${process.env.PUBLIC_URL || ''}/excel.png`} alt="Download Excel" className="excel-icon-img" />
                  )}
                </button>
              )}
            </div>
          )}
        </div>

        <button
          className="segment-action-btn segment-action-btn-save"
          onClick={handleSave}
          disabled={saving}
          type="button"
        >
          {saving ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Saving...
            </>
          ) : (
            'Save'
          )}
        </button>
      </div>

      <div className="segment-info-container">
        <div className="autoemail-toggle-container">
          <label className="autoemail-toggle-label">
            <input
              type="checkbox"
              checked={isAutoemail}
              onChange={handleIsAutoemailChange}
              className="autoemail-checkbox"
            />
            <span className="autoemail-toggle-text">Is Autoemail</span>
          </label>
        </div>

        
      </div>
    </div>
</>
  );
};

export default InlineFilters;
